import { GET_USER_URL, SET_USER_URL } from '../constants/Constant';
import axiosInstance from './AxiosInstance';

export const ProfileServices = {
  GetUser: async () => {
    const response = await axiosInstance.get(GET_USER_URL, {
      _silentErrors: true,
    });
    return response.data;
  },

  SetUser: async (userData: object) => {
    const response = await axiosInstance.post(SET_USER_URL, userData);
    return response.data;
  },
};
